import { buildFlux } from 'flux/buildFlux';
import {
  getCookieConsent,
  setConsentValue,
} from 'providers/CookieConsentProvider';
import React from 'react';
import { TrackJS } from 'trackjs';
import { WlWindow } from 'typings/globals/cordova';
import Logger from 'utils/Logger';
import { isCordova } from 'utils/platform';

import { CONSENT_COOKIES_KEYS } from './constants';
import TrackerRegistry from './trackers/registry';

const Analytics = require('@withlocals/withlocals-analytics').default;

declare const window: WlWindow;
const whenIdle = window.requestIdleCallback
  ? window.requestIdleCallback
  : (callback) => setTimeout(callback, 100);

function innerInit() {
  TrackJS.install({
    token: '3b2af3ceb8c64ed39d67b97a98b8e3d9',
    window: {
      promise: false,
    },
    version: withlocals_version,
    application: APPCONFIG.appName,
    enabled:
      !(window.location.host.indexOf('localhost') >= 0) &&
      !(window.location.host.indexOf('localbeta') >= 0),
  });

  TrackJS.addMetadata('version', withlocals_version);
  if (APPCONFIG && APPCONFIG.appName) {
    TrackJS.addMetadata('appname', APPCONFIG.appName);
  }

  if (DEBUG) {
    // needed for react chrome dev tools
    window.React = React;
  }

  if (window.isPreRender) {
    Logger.log(
      `setting consent saved to true because isPreRender == true (isPreRender: ${window.isPreRender})`,
    );
    setConsentValue(CONSENT_COOKIES_KEYS.CONSENT_SAVED, 'true');
  }

  const cookieConsent = getCookieConsent();

  const consentGiven = cookieConsent.base;

  const analyticsPlatform = CORDOVA_PLATFORM;

  Analytics.setCookieConsent(consentGiven);
  Analytics.setApplicationVersion(
    withlocals_version,
    analyticsPlatform,
    ENVIRONMENT,
  );

  if (consentGiven) {
    const consentAdvertisementGiven = cookieConsent.advertisement;
    const consentSocialGiven = cookieConsent.social;

    // If checks for new analytics lib, can be removed when new version is live.
    if (Analytics.setAdvertisementConsent) {
      Analytics.setAdvertisementConsent(consentAdvertisementGiven);
    }
    if (Analytics.setSocialConsent) {
      Analytics.setSocialConsent(consentSocialGiven);
    }
  }

  Logger.log('UE-version ' + withlocals_version); // eslint-disable-line no-undef

  if (/Android [4-6]/.test(navigator.appVersion)) {
    window.addEventListener('resize', () => {
      if (
        document.activeElement.tagName === 'INPUT' ||
        document.activeElement.tagName === 'TEXTAREA'
      ) {
        window.setTimeout(() => {
          const el: any = document.activeElement;
          if (el && el.scrollIntoViewIfNeeded) {
            el.scrollIntoViewIfNeeded();
          }
        }, 0);
      }
    });
  }
  if (window.cordova) {
    const reactContainer = document.getElementById('reactContainer');
    reactContainer.className += ` reactContainer-${window.cordova?.platformId}`;
  }

  whenIdle(() => {
    TrackerRegistry.init();

    // GTM
    const noScriptElement = document.createElement('noscript');
    const scriptElement = document.createElement('script');
    noScriptElement.innerHTML = `<iframe defer async src="https://www.googletagmanager.com/ns.html?id=GTM-5HN7SKJ" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    scriptElement.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', 'GTM-5HN7SKJ' );`;
    document.body.appendChild(noScriptElement);
    document.body.appendChild(scriptElement);
  });
}

export default function init() {
  if (isCordova()) {
    document.addEventListener('deviceready', innerInit, false);
  } else {
    innerInit();
  }

  return buildFlux();
}
